module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gC9qQ"))).then(() => parcelRequire('9Lwss'));